
import $ from "jquery";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

function Deolist() {
    const formattedTitle = useLocation().pathname
        .split('/').pop()
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    const navigate = useNavigate();
    const [showEditPassword, setShowEditPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleEditPassword = () => {
        setShowEditPassword(true);
    }

    const generatePassword = () => {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
        let pwd = "";
        for (let i = 0; i < 10; i++) pwd += chars[Math.floor(Math.random() * chars.length)];
        setNewPassword(pwd);
    };
    return (
        <>
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <section className="content-header">
                                        <h1><i className="fa fa-user" /> DEO list</h1>
                                        <ol className="breadcrumb">
                                            <li>
                                                <a onClick={() => navigate("/admin-dashboard")} style={{ cursor: "pointer" }}>
                                                    <i className="fa fa-tachometer" style={{ marginRight: "5px" }}></i> Home
                                                </a>
                                            </li>
                                            <li className="active">{formattedTitle}</li>
                                        </ol>
                                    </section>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-4 stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table id="studentTable" className="table table-condensed table-striped table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Sl No.</th>
                                                            <th>DEO ID</th>
                                                            <th>District</th>
                                                            <th style={{ width: 100 }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>1</td>
                                                            <td>2500001</td>
                                                            <td>Ranchi</td>
                                                            <td>
                                                                <button type="button" className="btn btn-sm btn-success"
                                                                    onClick={handleEditPassword}>
                                                                    <i className="fa fa-edit" />&nbsp;Edit Password
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            <AnimatePresence>
                {showEditPassword && (
                    <motion.div
                        className="modal-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            backdropFilter: "blur(8px)",
                            WebkitBackdropFilter: "blur(8px)",
                            zIndex: 1100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <motion.div
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            style={{
                                background: "#fff",
                                borderRadius: "12px",
                                width: "95%",
                                maxWidth: "600px",
                                position: "relative",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <form>
                                <div
                                    style={{
                                        padding: "15px 30px",
                                        borderBottom: "1px solid #ddd",
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                    }}
                                >
                                    Edit DEO's Password
                                    <button
                                        type="button"
                                        onClick={() => setShowEditPassword(false)}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "20px",
                                            background: "transparent",
                                            border: "none",
                                            fontSize: "24px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                    >
                                        &times;
                                    </button>
                                </div>

                                <div style={{ padding: "20px 30px" }}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Sl. No.</label>
                                                <input type="text" className="form-control form-control-sm" defaultValue={1} disabled />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>DEO ID</label>
                                                <input type="text" className="form-control form-control-sm" defaultValue={2500001} disabled />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="from-group">
                                                <label>District</label>
                                                <input type="text" className="form-control form-control-sm" defaultValue="Ranchi" disabled />
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="from-group">
                                                <label>Set DEO's Password</label>
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                        className="form-control form-control-sm"
                                                    />
                                                    <i
                                                        className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        style={{ cursor: "pointer", marginLeft: "10px" }}
                                                    />
                                                </div>
                                            </div>
                                            <button type="button" className="btn btn-link p-0"
                                                onClick={generatePassword} style={{ textDecoration: "none" }}>
                                                <i className="fa fa-magic me-1"></i> Generate Password
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        padding: "15px 30px",
                                        borderTop: "1px solid #ddd",
                                        textAlign: "right",
                                    }}
                                >
                                    <button type="submit" className="btn btn-primary btn-sm">
                                        <i className="fa fa-save"></i> Submit
                                    </button>
                                </div>
                            </form>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>


        </>
    )
}

export default Deolist